import { format } from 'date-fns'
import { fr } from 'date-fns/locale'

/** "3 janvier 2026" */
export function formatDateLong(isoDate: string): string {
  return format(new Date(isoDate), 'd MMMM yyyy', { locale: fr })
}

/** "03/01/2026" */
export function formatDateShort(isoDate: string): string {
  return format(new Date(isoDate), 'dd/MM/yyyy', { locale: fr })
}
